import {
  DomainEventOrInternal,
  InternalQueryCommand,
  QueryProcessor,
} from '@withlocals/cqrs.js/lib';
import isEqual from 'lodash.isequal';
import { Observable } from 'rxjs';

import { AuthState } from '../../model/AuthenticationInfo';
import {
  AuthenticatedEvent,
  AuthenticationChangedEvent,
  AuthenticationErrorEvent,
  NotAuthenticatedEvent,
  PasswordResetEvent,
} from './events';

export class InternalRefreshAuthCommand implements InternalQueryCommand {}

export const UnloggedAuthState: AuthState = {
  loading: false,
  offline: false,
  authInfo: null,
};

export const OfflineAuthState: AuthState = {
  loading: false,
  offline: true,
  authInfo: null,
};

export const InitialAuthState: AuthState = {
  loading: true,
  offline: true,
  authInfo: null,
};

export class AuthQueryProcessor extends QueryProcessor {
  private reducer(e: DomainEventOrInternal) {
    // console.debug(`AuthQueryProcessor$.reduce`, e, prevState);

    if (
      e instanceof InternalRefreshAuthCommand ||
      e instanceof AuthenticationChangedEvent
    ) {
      // const token: string = prevState.authInfo ? prevState.authInfo.token : null;
      // return this.apiProxy.getAuthInfoFromCacheOrApi(token);
    }
    if (e instanceof AuthenticatedEvent) {
      // return this.apiProxy.getAuthInfoFromCacheOrApi(e?.result?.authenticator?.id ?? '');
    }
    if (e instanceof PasswordResetEvent) {
      // console.debug(`AuthQueryProcessor$ returning PasswordResetEvent`);
      // return Observable.of({
      //   loading: false,
      //   offline: false,
      //   authInfo: null,
      // });
    }
    if (e instanceof NotAuthenticatedEvent) {
      // this.apiProxy.reset();
      // console.debug(`AuthQueryProcessor$ returning UnloggedAuthState`, UnloggedAuthState);
      // return Observable.of(UnloggedAuthState);
    }
    if (e instanceof AuthenticationErrorEvent) {
      // return Observable.of({
      //   loading: false,
      //   offline: false,
      //   authInfo: null,
      // });
    }

    // console.debug(`AuthQueryProcessor$ returning prevState`, prevState);
    return Observable.of({
      loading: false,
      offline: false,
      authInfo: null,
    });
  }

  readonly authInfo$: Observable<AuthState> = this.reduce(
    this.reducer.bind(this),
    InitialAuthState,
  )
    .distinctUntilChanged(isEqual)
    .shareReplay(1);
}
